import React from "react";

export function DetectedVariableBadges({
  tokens,
  registry,
}: {
  tokens: string[];
  registry: Record<string, string>;
}) {
  if (!tokens.length) return null;
  return (
    <div className="aa-glass-card p-3">
      <p className="text-[11px] uppercase tracking-wide text-muted-foreground">Detected variables</p>
      <div className="mt-2 flex flex-wrap gap-2">
        {tokens.map((token) => {
          const known = Boolean(registry[token]);
          return (
            <span
              key={`${token}-${known ? "known" : "unknown"}`}
              className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
                known ? "bg-success/20 text-success" : "bg-destructive/20 text-destructive"
              }`}
            >
              [{token}]
            </span>
          );
        })}
      </div>
    </div>
  );
}
